(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["decco-style-quiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  function parseOptions(raw){
    if(!raw) return [];
    return raw.split('\n').map(function(l){ return l.trim(); }).filter(Boolean).map(function(line){
      var parts = line.split('|');
      var label = (parts[0] || '').trim();
      var scores = {};
      if(parts[1]){
        parts[1].split(',').map(function(s){ return s.trim(); }).filter(Boolean).forEach(function(pair){
          var kv = pair.split(':');
          var k = (kv[0] || '').trim();
          var v = parseInt((kv[1] || '1').trim(), 10);
          if(k) scores[k] = isNaN(v) ? 0 : v;
        });
      }
      return { label: label, scores: scores };
    });
  }

  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function toArray(nl){ return Array.prototype.slice.call(nl); }

  function initDeccoQuiz(root){
    var selects = toArray(root.querySelectorAll('[data-decco-select]'));
    var panels = toArray(root.querySelectorAll('[data-decco-style]'));
    var resultsBox = root.querySelector('[data-decco-results]');
    var submit = root.querySelector('[data-decco-submit]');
    var message = root.querySelector('[data-decco-message]');
    var retake = root.querySelector('[data-decco-retake]');
    var incompleteMsg = root.getAttribute('data-incomplete') || '';

    selects.forEach(function(sel){
      var raw = '';
      try { raw = JSON.parse(sel.getAttribute('data-options') || '""'); }
      catch(e){ raw = sel.getAttribute('data-options') || ''; }
      var opts = parseOptions(raw);
      sel.__options = opts;
      var ph = sel.getAttribute('data-placeholder') || 'Select an option...';
      var html = '<option value="" disabled selected>' + escapeHtml(ph) + '</option>';
      opts.forEach(function(o, i){ html += '<option value="' + i + '">' + escapeHtml(o.label) + '</option>'; });
      sel.innerHTML = html;
    });

    function showPanel(winner){
      panels.forEach(function(p){ p.classList.remove('is-active'); p.setAttribute('hidden', ''); });
      if(resultsBox) resultsBox.removeAttribute('hidden');
      winner.removeAttribute('hidden');
      void winner.offsetWidth;
      winner.classList.add('is-active');
      if(!(window.Shopify && Shopify.designMode) && resultsBox){
        resultsBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function compute(){
      var scores = {}, answered = 0;
      selects.forEach(function(sel){
        var i = sel.selectedIndex;
        if(i <= 0) return;
        var o = sel.__options[i - 1];
        if(!o) return;
        answered++;
        for(var k in o.scores){ scores[k] = (scores[k] || 0) + o.scores[k]; }
      });

      if(answered === 0){ if(message) message.textContent = incompleteMsg; return; }

      var winner = null, best = -1;
      panels.forEach(function(p){
        var k = p.getAttribute('data-decco-style');
        var s = scores[k] || 0;
        if(s > best){ best = s; winner = p; }
      });

      if(!winner || best <= 0){ if(message) message.textContent = incompleteMsg; return; }
      if(message) message.textContent = '';
      showPanel(winner);
    }

    if(submit) submit.addEventListener('click', compute);
    if(retake) retake.addEventListener('click', function(){
      if(resultsBox) resultsBox.setAttribute('hidden', '');
      panels.forEach(function(p){ p.classList.remove('is-active'); p.setAttribute('hidden', ''); });
      selects.forEach(function(sel){ sel.selectedIndex = 0; });
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Preview de un estilo puntual desde el editor
    if(window.Shopify && Shopify.designMode){
      var pk = root.getAttribute('data-preview-key');
      if(pk){
        var target = panels.filter(function(p){ return p.getAttribute('data-decco-style') === pk; })[0];
        if(target) showPanel(target);
      }
    }
  }

  function initAll(){
    toArray(document.querySelectorAll('.decco-quiz')).forEach(function(r){
      if(r.__deccoInit) return;
      r.__deccoInit = true;
      initDeccoQuiz(r);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('.decco-quiz');
    if(el && !el.__deccoInit){ el.__deccoInit = true; initDeccoQuiz(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projects"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (!root || root.dataset.dpInit === 'true') return;
      root.dataset.dpInit = 'true';

      var state = { space: '', style: '' };
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-project]'));
      var noResults = root.querySelector('[data-no-results]');
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-filter-group]'));

      function applyFilters() {
        var visible = 0;
        items.forEach(function (item) {
          var okSpace = !state.space || item.getAttribute('data-space') === state.space;
          var okStyle = !state.style || item.getAttribute('data-style') === state.style;
          var show = okSpace && okStyle;
          item.hidden = !show;
          if (show) visible++;
        });
        if (noResults) noResults.hidden = visible !== 0;
      }

      function closeAllMenus(except) {
        groups.forEach(function (g) {
          if (g === except) return;
          g.classList.remove('is-open');
          var p = g.querySelector('.decco-projects__pill');
          if (p) p.setAttribute('aria-expanded', 'false');
        });
      }

      groups.forEach(function (group) {
        var type = group.getAttribute('data-filter-group');
        var pill = group.querySelector('.decco-projects__pill');
        var label = group.querySelector('[data-pill-label]');
        var defaultLabel = label ? label.textContent : '';
        var options = Array.prototype.slice.call(group.querySelectorAll('.decco-projects__option'));

        pill.addEventListener('click', function (e) {
          e.stopPropagation();
          var willOpen = !group.classList.contains('is-open');
          closeAllMenus(group);
          group.classList.toggle('is-open', willOpen);
          pill.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });

        options.forEach(function (opt) {
          opt.addEventListener('click', function () {
            var value = opt.getAttribute('data-value') || '';
            state[type] = value;
            options.forEach(function (o) { o.classList.toggle('is-active', o === opt); });
            if (label) label.textContent = value ? value : defaultLabel;
            group.classList.toggle('is-selected', !!value);
            group.classList.remove('is-open');
            pill.setAttribute('aria-expanded', 'false');
            applyFilters();
          });
        });
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) closeAllMenus(null);
      });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAllMenus(null);
      });
    }

    function initAll() {
      document.querySelectorAll('[data-decco-projects]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-decco-projects]');
      if (root) { root.dataset.dpInit = ''; initSection(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bardo-section-tabs')) {
    class BardoSectionTabs extends HTMLElement {
      connectedCallback() {
        this.sid = this.dataset.sectionId;
        this.chips = Array.from(this.querySelectorAll('.bst__chip'));
        this.panels = [];
        this.current = null;
        if (!this.chips.length) return;

        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => this.activate(chip.dataset.tab, true));
          chip.addEventListener('keydown', (e) => this.onKey(e));
        });

        this.onEditor = this.onEditor.bind(this);
        this.editorEvents = [
          'shopify:section:load',
          'shopify:section:unload',
          'shopify:section:reorder',
          'shopify:section:select',
          'shopify:block:select'
        ];
        this.editorEvents.forEach((ev) => document.addEventListener(ev, this.onEditor));

        this.collect();
        this.activate(this.initialTab(), false);
      }

      disconnectedCallback() {
        if (this.editorEvents) {
          this.editorEvents.forEach((ev) => document.removeEventListener(ev, this.onEditor));
        }
        this.release();
      }

      /* Libera las secciones que esta instancia tenía tomadas */
      release() {
        document.querySelectorAll('[data-bst-owner="' + this.sid + '"]').forEach((el) => {
          el.classList.remove('bst-hidden');
          delete el.dataset.bstOwner;
          delete el.dataset.bstTab;
        });
      }

      /* Toma las N secciones siguientes para cada tab, en orden */
      collect() {
        this.release();
        this.panels = [];
        const host = this.closest('.shopify-section');
        if (!host) return;

        let el = host.nextElementSibling;
        this.chips.forEach((chip, i) => {
          const count = parseInt(chip.dataset.count, 10) || 1;
          const group = [];
          for (let n = 0; n < count; n++) {
            while (el && !el.classList.contains('shopify-section')) el = el.nextElementSibling;
            // corta si no hay más secciones o si aparece otra sección de tabs
            if (!el || el.querySelector('bardo-section-tabs')) { el = null; break; }
            el.dataset.bstOwner = this.sid;
            el.dataset.bstTab = String(i);
            group.push(el);
            el = el.nextElementSibling;
          }
          this.panels[i] = group;
        });
      }

      chipFor(tab) {
        return this.chips.find((c) => c.dataset.tab === String(tab));
      }

      initialTab() {
        if (this.dataset.deeplink === 'true') {
          const wanted = new URLSearchParams(window.location.search).get('tab');
          const match = wanted && this.chips.find((c) => c.dataset.handle === wanted);
          if (match) return match.dataset.tab;
        }
        return this.chips[0].dataset.tab;
      }

      activate(tab, fromUser) {
        let chip = this.chipFor(tab);
        if (!chip) chip = this.chips[0];
        this.current = chip.dataset.tab;

        this.chips.forEach((c) => {
          const on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', on ? 'true' : 'false');
          c.tabIndex = on ? 0 : -1;
        });

        this.panels.forEach((group, i) => {
          group.forEach((el) => el.classList.toggle('bst-hidden', String(i) !== this.current));
        });

        if (fromUser) {
          if (this.dataset.deeplink === 'true') {
            const url = new URL(window.location.href);
            url.searchParams.set('tab', chip.dataset.handle);
            window.history.replaceState(window.history.state, '', url);
          }
          chip.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        }

        // sliders/carruseles del theme recalculan medidas al mostrarse
        requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      }

      onKey(e) {
        const i = this.chips.indexOf(e.currentTarget);
        let next = null;
        if (e.key === 'ArrowRight') next = this.chips[(i + 1) % this.chips.length];
        if (e.key === 'ArrowLeft') next = this.chips[(i - 1 + this.chips.length) % this.chips.length];
        if (e.key === 'Home') next = this.chips[0];
        if (e.key === 'End') next = this.chips[this.chips.length - 1];
        if (!next) return;
        e.preventDefault();
        next.focus();
        this.activate(next.dataset.tab, true);
      }

      /* Theme editor: reagrupa al mover/agregar secciones y abre el tab de lo que selecciones */
      onEditor(e) {
        const type = e.type;
        if (type === 'shopify:section:load' || type === 'shopify:section:unload' || type === 'shopify:section:reorder') {
          setTimeout(() => {
            if (!this.isConnected) return;
            this.collect();
            this.activate(this.current, false);
          }, 0);
          return;
        }
        if (type === 'shopify:section:select') {
          const el = document.getElementById('shopify-section-' + e.detail.sectionId);
          if (el && el.dataset.bstOwner === this.sid) {
            this.activate(el.dataset.bstTab, false);
          }
          return;
        }
        if (type === 'shopify:block:select' && e.detail.sectionId === this.sid) {
          const chip = this.chips.find((c) => c.dataset.blockId === e.detail.blockId);
          if (chip) this.activate(chip.dataset.tab, false);
        }
      }
    }
    customElements.define('bardo-section-tabs', BardoSectionTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
